export default __webpack_public_path__ + "static/media/UFC.33a0449b.jpg";